import { useEffect, useRef } from "react";

/** Vertical kinetic pipeline — used on Approach page sticky column */
export default function PipelineV({ height = 800 }) {
  const ref = useRef(null);
  useEffect(() => {
    const c = ref.current; if (!c) return;
    const ctx = c.getContext("2d");
    const dpr = window.devicePixelRatio || 1;
    const resize = () => {
      c.width = c.clientWidth * dpr; c.height = c.clientHeight * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    resize(); window.addEventListener("resize", resize);

    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const N = reduce ? 80 : 220;
    const pts = Array.from({ length: N }, () => ({
      x: Math.random() * 100,
      y: Math.random() * c.clientHeight,
      vy: 0.5 + Math.random() * 0.7,
      seed: Math.random() * Math.PI * 2,
      size: 0.8 + Math.random() * 1.3,
    }));
    const lerp = (a, b, t) => a + (b - a) * t;

    let raf;
    const draw = () => {
      const w = c.clientWidth, h = c.clientHeight;
      ctx.clearRect(0, 0, w, h);
      [0.15, 0.4, 0.65, 0.9].forEach((p) => {
        const sy = p * h;
        ctx.strokeStyle = "rgba(255,255,255,0.07)";
        ctx.setLineDash([2, 6]);
        ctx.beginPath(); ctx.moveTo(20, sy); ctx.lineTo(w - 20, sy); ctx.stroke();
        ctx.setLineDash([]);
      });
      pts.forEach((p) => {
        p.y += p.vy;
        if (p.y > h + 10) { p.y = -10; p.x = Math.random() * 100; }
        const t = p.y / h;
        let xPct;
        if (t < 0.27) xPct = p.x + Math.sin(p.seed + p.y * 0.04) * 12;
        else if (t < 0.52) {
          const a = (t - 0.27) / 0.25;
          const tc = Math.floor(p.seed * 2.4) % 6;
          xPct = lerp(p.x + Math.sin(p.seed + p.y * 0.04) * 12, 12 + (tc / 5) * 78, a);
        } else if (t < 0.77) {
          const tc = Math.floor(p.seed * 2.4) % 6;
          xPct = 12 + (tc / 5) * 78 + Math.sin(p.y * 0.05 + p.seed) * 2;
        } else {
          const tc = Math.floor(p.seed * 2.4) % 6;
          xPct = 12 + (tc / 5) * 78;
        }
        const x = (xPct / 100) * w;
        const r = Math.round(lerp(232, 220, t));
        const g = Math.round(lerp(180, 230, t));
        const b = Math.round(lerp(120, 240, t));
        ctx.fillStyle = `rgba(${r},${g},${b},${0.4 + t * 0.5})`;
        ctx.beginPath(); ctx.arc(x, p.y, p.size + (t > 0.77 ? 0.4 : 0), 0, Math.PI * 2); ctx.fill();
        if (t > 0.8) {
          ctx.strokeStyle = `rgba(220,230,240,${(t - 0.8) * 0.5})`;
          ctx.lineWidth = 0.5;
          ctx.beginPath(); ctx.moveTo(x, p.y - 5); ctx.lineTo(x, p.y + 5); ctx.stroke();
        }
      });
      raf = requestAnimationFrame(draw);
    };
    draw();
    return () => { cancelAnimationFrame(raf); window.removeEventListener("resize", resize); };
  }, []);
  return <canvas ref={ref} className="w-full block" style={{ width: "100%", height }} />;
}
